import { Injectable } from '@angular/core';

//Zur Wiederverwendung im Rahmen der USignal-Administration
@Injectable()
export class USignalEffects {
	constructor() {}
}
